<template>
    <div>
        <Head :title="'訪客訂單 #' + $page.props.order_no" />

        <div class="my-10 text-xl text-bold text-center">訂單狀態</div>

        <div class="my-10">
            <div class="info-item">
                <label>訂單資訊 <small>(部分)</small></label>
                <div class="info-subitem">
                    <div class="column">
                        <label>訂單號碼</label>
                        {{ $page.props.order_no }}
                    </div>
                    <div class="column">
                        <label>訂單狀態</label>
                        {{ statusString($page.props.order_status) }}
                    </div>
                </div>

                <div>
                    <small class="text-red">
                        因保護個人資料等敏感資訊的原因，無法於此提供完整訂單明細資訊。
                    </small>
                </div>
            </div>
        </div>

        <div
            class="flex flex-col sm:justify-center items-center mx-auto my-14 card"
        >
            <div>
                如需取得更多資訊，請使用「訂單付款人」使用之「連絡電話」或「電子郵件」進行身分驗證。
            </div>

            <div class="my-5">
                <div>
                    <InputText
                        id="purchaser_info"
                        class="w-60"
                        type="text"
                        v-model="purchaser_info"
                        placeholder="付款人連絡電話或電子郵件"
                    />
                    <div
                        v-if="$page.props.errors.purchaser_info"
                        class="text-red mt-1 pl-1"
                    >
                        <i class="pi pi-arrow-up" />
                        {{ $page.props.errors.purchaser_info }}
                    </div>
                </div>
                <div class="my-5 text-center">
                    <Button
                        type="submit"
                        label="查看訂單明細"
                        icon="pi pi-search"
                        iconPos="left"
                        @click="submit"
                        :disabled="purchaser_info.length == 0"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import InputText from "primevue/inputtext";
import Button from "primevue/button";

export default {
    layout: Layout,
    components: {
        InputText,
        Button,
    },
    filters: {
        // priceFormat: function (value) {
        //     return "$" + value;
        // },
        // commaFormat: function (value) {
        //     return value
        //         .toString()
        //         .replace(
        //             /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
        //             function (all, pre, groupOf3Digital) {
        //                 return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
        //             }
        //         );
        // },
    },
    data() {
        return {
            purchaser_info: "",
        };
    },
    computed: {
        //
    },
    methods: {
        statusString(statusCode) {
            return this.$page.props.status_strings[statusCode];
        },

        submit() {
            this.$inertia.post(
                route("guest.orders.order", this.$page.props.order_no),
                { purchaser_info: this.purchaser_info },
                {
                    preserveScroll: true,
                }
            );
        },
    },
};
</script>

<style lang="postcss">
.info-item {
    @apply mb-5 p-2 border border-fh-gray-border;
}

.info-subitem {
    @apply mt-2 py-2 flex justify-start flex-wrap gap-8;
}

.info-subitem .column {
    @apply flex flex-col;
}

.info-subitem .column label {
    @apply text-xs;
}

.crossed {
    @apply text-red line-through;
}
</style>
